import Profile from "./Profile.png";
import Call from "./call.png";
import CalenderIcon from "./calendarIcon.png";
import SmsIcon from "./sms-tracking.png";
import ArrowLeftSvg from "./left.svg";
import enFlag from "./enFlag.png";
import vnFlag from "./vnFlag.webp";
import frFlag from "./frFlag.png";
import filterIcon from "./filterIcon.png";
import profile from "./Profile.png";
import leftArrow from "./LeftArrow.png";
import rightArrow from "./RightArrow.png";
import extraIcon from "./ExtraIcon.png";
import openBox from "./openBox.png";
import statusCross from "./statusCross.png";
import inReview from "./inReview.png";
import noProfile from "./noProfile.svg";
import step from "./step.svg";
import stepChecked from "./stepChecked.svg";
import NoData from "./NoData.png";
import CircleCross from "./circleCross.svg";
import Quoted from "./Quoted.svg";
import Location from "./location.svg";
import redPlus from "./redPlus.svg";
import eye from "./eye.svg";
import blackCalender from "./blackCalender.svg";
import plusIcon from "./plus.png";
import trashIcon from "./trash.svg";
import cross from "./circle-x-filled.png";
import edit from "./edit.svg";
import plusIconGreen from "./PlusIcon.png";
import tncPP from "./tnc.svg";
import Check from "./CheckMark.png";
import profileNurse from "./profileNurse.svg";
import downArrow from "./downArrow.png";
import draft from "./draftIcon.svg";
import publish from "./publishIcon.svg";
import trashNurse from "./trashNurse.svg";
import tick from "./tick.svg";
import gender from "./gender.svg";
import insurance from "./insurance.svg";
import PdfRedIcon from "./redpdf.svg";
import upload from "./upload.svg";
import profileimg from "./profileimg.jpeg";
import spinnerSolid1 from "./spinner-solid 1.png";
import exportSpecimen from "./export-specimen.png";
import submitSpecimen from "./submitted-specimen.png";
import pendingSpecimen from "./pending-specimen.png";
import checkSolid from "./check-solid-additional.png";
import abIcon from "./absconding-icon-additinal.png";
import id from "./id.svg";
import downloadingUpdates from "./Downloading Updates.svg";
import chatIcon from "./chatIcon.svg";

const Icons = {
  Profile,
  tick,
  gender,
  insurance,
  spinnerSolid1,
  Check,
  Call,
  CalenderIcon,
  SmsIcon,
  ArrowLeftSvg,
  enFlag,
  vnFlag,
  frFlag,
  filterIcon,
  profile,
  leftArrow,
  rightArrow,
  extraIcon,
  openBox,
  statusCross,
  inReview,
  noProfile,
  step,
  stepChecked,
  NoData,
  CircleCross,
  Quoted,
  Location,
  redPlus,
  eye,
  blackCalender,
  plusIcon,
  trashIcon,
  cross,
  edit,
  plusIconGreen,
  tncPP,
  draft,
  publish,
  profileNurse,
  downArrow,
  trashNurse,
  PdfRedIcon,
  upload,
  profileimg,
  exportSpecimen,
  submitSpecimen,
  pendingSpecimen,
  checkSolid,
  abIcon,
  id,
  downloadingUpdates,
  chatIcon,
};

export default Icons;
